import { Map } from 'immutable';
import {
    GET_SURVEY_OPTIONS,
    GET_SURVEY_OPTIONS_FAIL,
    GET_SURVEY_OPTIONS_SUCCESS
} from 'constants/actionTypes';

const init = Map({});

export default function surveyOptionsReducer(state = init, action) {
    switch (action.type) {
    case GET_SURVEY_OPTIONS:
        return state;
    case GET_SURVEY_OPTIONS_FAIL:
        return state.merge({ errors: action.payload });
    case GET_SURVEY_OPTIONS_SUCCESS:
        return state.merge(action.payload);
    default:
        return state;
    }
}
